<ng-container *ngIf="eventId;else addBtn">
  <button aria-describedby="seebelow{{itemindex}}" type="button" class="btn btn-sm btn-link p-0" (click)="scrollToRMSData.emit(eventId)" *ngIf="!isOutsideAgency()">[See below]</button>
  <div id="{{'seebelow' + itemindex}}" #seebelow class="visually-hidden">Selects the referenced crime gun event row in the RMS Events table.</div>
  <ng-container *ngIf="isOutsideAgency()">
    [Outside agency]
  </ng-container>
</ng-container>
<ng-template #addBtn>
  <button *removeIfNoPermission="canCreate" aria-describedby="addrms{{itemindex}}" type="button" class="btn btn-sm btn-active" (click)="showDataSlideout.emit()">Add</button>
  <div id="{{'addrms' + itemindex}}" #addrms class="visually-hidden">
    Navigates to the add new event page and populates form field with the known values from the evidence data.
  </div>
  <ng-container *ngIf="isOutsideAgency()">[Outside agency]</ng-container>
</ng-template>
